import { api } from "@/lib/api";

export async function fetchEqModules() {
  const { data } = await api.get("/equilibrium/modules");
  return data;
}

export async function fetchEqModule(key) {
  const { data } = await api.get(`/equilibrium/modules/${key}`);
  return data;
}

export async function submitEqDiagnostic(payload) {
  const { data } = await api.post("/equilibrium/diagnostics", payload);
  return data;
}

export async function fetchEqDiagnostics() {
  const { data } = await api.get("/equilibrium/diagnostics");
  return data;
}

export async function fetchEqProvenance(limit = 200) {
  const { data } = await api.get(`/equilibrium/provenance/events?limit=${limit}`);
  return data;
}

export async function fetchEqCoherence() {
  const { data } = await api.get("/equilibrium/signals/coherence");
  return data;
}

export async function fetchEqOverview() {
  const { data } = await api.get("/equilibrium/console/overview");
  return data;
}
